import React from 'react';

import { LinkText } from 'common/components';
import { Glossary, CommonGL } from 'common/utils/glossary';

interface FooterProps {
  /** グロッサリ */
  glossary: Glossary;
  /** プラン一覧の押下処理 */
  onClickPlanList: () => void;
  /** 利用ガイドの押下処理 */
  onClickGuide: () => void;
  /** FAQの押下処理 */
  onClickFaq: () => void;
  /** お問い合わせの押下処理 */
  onClickContact: () => void;
  /** 利用規約の押下処理 */
  onClickTermsOfService: () => void;
  /** プライバシーポリシーの押下処理 */
  onClickPrivacyPolicy: () => void;
  /** クッキーポリシーの押下処理 */
  onClickCookiePolicy: () => void;
}

/**
 * フッターのPresentation Component
 */
export const Footer: React.FC<FooterProps> = ({
  glossary,
  onClickPlanList,
  onClickGuide,
  onClickFaq,
  onClickContact,
  onClickTermsOfService,
  onClickPrivacyPolicy,
  onClickCookiePolicy
}) => {
  return (
    <section id="footer">
      <ul className="linearLayout">
        {/* プラン一覧 */}
        <LinkText
          type="detailLink"
          data-test={`footerPlanListLink`}
          onClick={onClickPlanList}
        >
          {glossary.glx(CommonGL.PlanList)}
        </LinkText>

        {/* 利用ガイド */}
        <LinkText
          type="detailLink"
          data-test={`footerGuideLink`}
          onClick={onClickGuide}
        >
          {glossary.glx(CommonGL.Guide)}
        </LinkText>

        {/* FAQ */}
        <LinkText
          type="detailLink"
          data-test={`footerFaqLink`}
          onClick={onClickFaq}
        >
          {glossary.glx(CommonGL.Faq)}
        </LinkText>

        {/* 問い合わせ */}
        <LinkText
          type="detailLink"
          data-test={`footerContactLink`}
          onClick={onClickContact}
        >
          {glossary.glx(CommonGL.ContactUs)}
        </LinkText>

        {/* 利用規約 */}
        <LinkText
          type="detailLink"
          data-test={`footerTermsOfServiceLink`}
          onClick={onClickTermsOfService}
        >
          {glossary.glx(CommonGL.TermsOfService)}
        </LinkText>

        {/* プライバシーポリシー */}
        <LinkText
          type="detailLink"
          data-test={`footerPrivacyPolicyLink`}
          onClick={onClickPrivacyPolicy}
        >
          {glossary.glx(CommonGL.PrivacyPolicy)}
        </LinkText>

        {/* クッキーポリシー */}
        <LinkText
          type="detailLink"
          data-test={`footerCookiePolicyLink`}
          onClick={onClickCookiePolicy}
        >
          {glossary.glx(CommonGL.CookiePolicy)}
        </LinkText>
      </ul>
      <div id="copyright">{glossary.glx(CommonGL.Copyright)}</div>
    </section>
  );
};
